export default function ProcessStepSimple( { step, stepNumber } ) {
  return (
    <li>
      <span>{ stepNumber }</span>
      <span>{ step.stepText }</span>
    </li>
  )
}
